import type {
  UserPreferencesNotificationsMenuItemAction,
  UserPreferencesNotificationsMenuItemDivider,
} from "./user-preferences-notifications-dropdown.type";
import type { UserPreferencesNotificationsAction } from "../user-preferences-notifications.type";
import type { NotificationsChannelType } from "@/entities/referential/referential-notifications";

import { ReloadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export const useUserPreferencesNotificationsDropdownBuilder = () => {
  const { t } = useTranslation();

  const buildAction = (
    action: UserPreferencesNotificationsAction,
    channel?: NotificationsChannelType
  ): UserPreferencesNotificationsMenuItemAction => {
    return {
      key: channel ? `${channel}-${action}` : action,
      label: t(`user:preferences.notifications.actions.${action}`),
      icon: action === "reset" ? <ReloadOutlined /> : undefined,
      action,
      channel,
    };
  };

  const buildDivider = (): UserPreferencesNotificationsMenuItemDivider => {
    return { type: "divider" };
  };

  return {
    buildAction,
    buildDivider,
  };
};
